import { FormattedNumber, FormattedMessage } from 'react-intl';

import { Card } from 'ui-components/components/card';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { FormattedCurrency } from '../../../../../../components/formatted-currency';
import { PromotionalBanner } from '../../../../../../components/promotional-banner';
import { getDiscountedValues } from '../helpers';
import { modalMessages } from '../messages';
import { PlanCard } from './plan-card';
import { PlanName } from './plan-name';
import { PromotionalFeatureList } from './promotional-feature-list';
import style from '../migration-plan-modal.module.less';

export const PromotionalOfferPlanCard = ({ planDetails }) => {
  const { discountPercentage } = planDetails;

  const { discountedPrice, discountedSaving } = getDiscountedValues({
    fullPrice: planDetails.pricePerMonth.value,
    discountPercentage,
  });

  return (
    <Card>
      <PlanName name={planDetails.name} />
      <PlanCard planDetails={planDetails} promotionalPrice={discountedPrice} />
      <PromotionalBanner
        promotionalHeaderMessage={modalMessages.modalBannerHeader}
        promotionalSubheaderMessage={
          <FormattedMessage
            {...modalMessages.modalBannerSubheader}
            values={{
              price: <FormattedCurrency value={discountedSaving} />,
              percent: <FormattedNumber style='percent' value={discountPercentage} />,
            }}
          />
        }
      />
      <FlexColumn className={style['feature-section']}>
        <Text textType={TextType.Label} value={modalMessages.featureListHeader} />
        <PromotionalFeatureList billingPlanId={planDetails.billingPlanId} />
        <Text className={style['call-to-action-text']} textType={TextType.H4} value={modalMessages.callToActionMessage} />
      </FlexColumn>
    </Card>
  );
};
